import type { ContentNode, TemplateContent } from "@/types/template";
import type { SubTemplateData } from "@/types/evaluation";

/**
 * Build the initial SubTemplateData tree for all sub-template fields
 * found within the given content nodes (recursive, with cycle detection).
 */
export function initSubTemplateData(
  content: ContentNode[],
  getContent: (id: string) => TemplateContent | undefined,
  visited = new Set<string>(),
): Record<string, SubTemplateData> {
  const result: Record<string, SubTemplateData> = {};
  for (const node of content) {
    if (node.type !== "field" || node.field.type !== "sub-template") {
      continue;
    }
    const { templateId } = node.field;
    if (visited.has(templateId)) {
      continue;
    }
    const templateContent = getContent(templateId);
    if (templateContent) {
      const subContent = templateContent.content;
      const nextVisited = new Set(visited);
      nextVisited.add(templateId);

      const sectionToggles: Record<string, boolean> = {};
      for (const n of subContent) {
        if (n.type === "section") {
          sectionToggles[n.id] = true;
        }
      }

      result[node.field.id] = {
        content: subContent,
        sectionToggles,
        subTemplateValues: initSubTemplateData(subContent, getContent, nextVisited),
        templateId,
        templateName: templateContent.name,
        values: {},
      };
    }
  }
  return result;
}
